<template>
  <v-container class="pa-0">
    <p class="display-1 black--text">¡Hola!</p>
    <p class="subtitle-1 my-1">Inicia sesión con tu número de móvil</p>
    <v-form ref="form" :value="v">
      <VuePhoneNumberInput
        class="mt-0"
        v-if="isVerificar"
        v-model="tlf"
        @update="changePhone"
        no-validator-state
        fetch-country
        :translations="traducciones"
        :preferred-countries="['ES','FR', 'BE', 'DE']"
      />
      <CodeInput
        :autoFocus="true"
        v-else
        :loading="loading"
        :fields="6"
        type="number"
        class="input mx-auto mb-3 ma-sm-0"
        v-on:change="changeCodigo"
        v-on:complete="completeCodigo"
      />
      <div class="my-4" v-html="htmlRecaptcha"></div>
    </v-form>
    <v-btn
      id="verificar"
      tile
      large
      block
      class="pa-3 mt-4 success"
      :disabled="!isValidNumber"
      v-if="isVerificar"
      @click="verificar"
      :loading="loading"
    >Verificar</v-btn>
    <v-btn
      id="validar"
      tile
      large
      block
      class="pa-3 mt-4 success"
      :disabled="!isValidCodigo"
      v-else
      @click="comprobarCodigo"
      :loading="loading"
    >Confirmar Código</v-btn>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import firebase from "firebase";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import CodeInput from "vue-verification-code-input";

export default {
  name: "loginForm",
  components: {
    VuePhoneNumberInput,
    CodeInput
  },
  data() {
    return {
      loading: false,
      v: true,
      colorTextField: "success",
      tlf: "",
      dataNumber: null,
      recaptchaVerificado: false,
      accion: "verificar",
      codigo: "",
      email: "",
      htmlRecaptcha: '<div id="recaptcha-container" ref="recaptcha"></div>',
      generandorecaptcha: false,
      traducciones: {
        countrySelectorLabel: "Pais",
        countrySelectorError: "Elige un pais",
        phoneNumberLabel: "Número de telefono",
        example: "Ejemplo :"
      }
    };
  },
  computed: {
    isVerificar() {
      return this.accion == "verificar";
    },
    isComprobar() {
      return this.accion == "comprobar";
    },
    ...mapState({
      isTablet: state => state.app.isTablet,
      isMobile: state => state.app.isMobile,
      dialogFinalizar: state => state.app.dialogFinalizar
    }),
    dialogLogin: {
      get() {
        return this.$store.state.app.dialogLogin;
      },
      set(value) {
        this.$store.commit("app/setDialogLogin", value);
      }
    },
    /*loading: {
      get() {
        return this.$store.state.app.loading;
      },
      set(v) {
        this.$store.commit("app/setLoading", v);
      }
    },*/
    pasoFinalizar: {
      get: function() {
        return this.$store.state.pedido.pasoFinalizar;
      },
      set: function(valor) {
        this.$store.commit("pedido/setPasoFinalizar", valor);
      }
    },
    loginCaptchaActivo: {
      get() {
        return this.$store.state.auth.loginCaptchaActivo;
      },
      set(value) {
        this.$store.commit("auth/setLoginCaptchaActivo", value);
      }
    },
    formattedNumber() {
      return this.dataNumber ? this.dataNumber.formattedNumber : "";
    },
    isValidNumber() {
      return this.dataNumber
        ? this.dataNumber.isValid /*&& this.recaptchaVerificado*/
        : false;
    },
    isValidCodigo() {
      return /*this.recaptchaVerificado &&*/ this.codigo.length == 6;
    }
  },
  methods: {
    ...mapActions({
      getDirecciones: "direcciones/getDirecciones"
    }),
    changeCodigo(val) {
      this.codigo = val;
    },
    completeCodigo(val) {
      this.codigo = val;
    },
    changePhone(data) {
      this.dataNumber = data;
    },
    validate(data) {},
    resetRecaptcha() {
      this.accion = "verificar";
      this.htmlRecaptcha =
        '<div id="recaptcha-container" ref="recaptcha"></div>';
    },
    r() {
      //firebase.auth().settings.appVerificationDisabledForTesting = true;
      firebase.auth().languageCode = "es";
      let _vm = this;
      this.windowRef = window;
      this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "verificar",
        {
          size: "invisible",
          callback: function(response) {
            _vm.recaptchaVerificado = true;
          },
          "expired-callback": function() {}
        }
      );
      /*this.windowRef.recaptchaVerifier.render().then(widgetId => {
        console.log(widgetId);
        window.recaptchaWidgetId = widgetId;
        this.windowRef.recaptchaWidgetId = widgetId;
        var recaptchaResponse = grecaptcha.getResponse(
          window.recaptchaWidgetId
        );
        console.log(recaptchaResponse);
      });*/
    },
    verificar() {
      var phoneNumber = this.formattedNumber;
      var appVerifier = this.windowRef.recaptchaVerifier;
      let _vm = this;
      if (phoneNumber && appVerifier) {
        _vm.loading = true;
        firebase
          .auth()
          .signInWithPhoneNumber(phoneNumber, appVerifier)
          .then(function(confirmationResult) {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Hemos enviado el SMS, comprueba tu teléfono"
            });
            window.confirmationResult = confirmationResult;
            _vm.accion = "comprobar";
            _vm.recaptchaVerificado = false;
          })
          .catch(function(error) {
            // Error; SMS not sent
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: _vm.$t(error.code)
            });
          })
          .finally(function(f) {
            _vm.loading = false;
          });
      } else {
      }
    },
    comprobarCodigo() {
      var code = this.codigo;
      let _vm = this;
      _vm.loading = true;
      window.confirmationResult
        .confirm(code)
        .then(function(result) {
          //Lógica de continuación tras el Log o Registro
          let nuevoRegistro = result.additionalUserInfo.isNewUser;

          if (_vm.dialogFinalizar && _vm.pasoFinalizar == 2) {
            _vm.$store.commit("pedido/setUsuarioConfirmado", true);
            let goToPaso = 3;
            if (nuevoRegistro) goToPaso = 2;
            _vm.pasoFinalizar == goToPaso;
          } else if (_vm.dialogLogin) {
            _vm.$store.dispatch("auth/getFormasPago");
            _vm.dialogLogin = false;
          } else {
          }

          // _vm.dialogLogin = false;
          // User signed in successfully.
          // _vm.$router.push('/')
        })
        .catch(function(error) {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: _vm.$t(error.code)
          });
          console.log(error);
        })
        .finally(function() {
          _vm.loading = false;
        });
    }
  },
  mounted() {
    this.r();
  },
  watch: {
    dialogLogin(old, newValue) {
      if (newValue) {
        this.accion = "verificar";
      }
    }
  }
};
</script>

<style scoped>
</style>